import '../../../../packages/frontend/components/arti24/arti24.js';
import '../../../../packages/frontend/components/arti24/arti24-stats-link.js';
const form = document.querySelector<HTMLFormElement>('#idea-filters');
if (form) {
    const cards = [...document.querySelectorAll<HTMLElement>('.idea-card')];
    const categories = [...form.querySelectorAll<HTMLButtonElement>('[data-category]')];
    const count = document.querySelector<HTMLElement>('#result-count')!;
    const countTemplate = count.dataset.countTemplate!;
    const empty = document.querySelector<HTMLElement>('#empty-state')!;
    const surprise = document.querySelector<HTMLButtonElement>('#surprise')!;
    let category = '';
    const normalize = (value: string) =>
        value
            .toLocaleLowerCase('pl')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/ł/g, 'l');
    function filter() {
        const data = new FormData(form!);
        const query = normalize(String(data.get('query') ?? '').trim());
        const intent = data.get('intent');
        const audience = data.get('audience');
        for (const card of cards) {
            card.hidden = !(
                (!category || card.dataset.category === category) &&
                (!intent || card.dataset.intent === intent) &&
                (!audience || card.dataset.audience === audience) &&
                normalize(card.textContent ?? '').includes(query)
            );
        }
        const visible = cards.filter((card) => !card.hidden).length;
        count.textContent = countTemplate
            .replaceAll('{visible}', String(visible))
            .replaceAll('{total}', String(cards.length));
        empty.hidden = visible !== 0;
        surprise.disabled = visible === 0;
        categories.forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.category === category));
        });
    }
    form.addEventListener('submit', (event) => event.preventDefault());
    form.addEventListener('input', filter);
    form.addEventListener('change', filter);
    categories.forEach((button) => {
        button.addEventListener('click', () => {
            category = button.dataset.category ?? '';
            filter();
        });
    });
    document.querySelector('#reset-filters')?.addEventListener('click', () => {
        form.reset();
        category = '';
        filter();
        form.querySelector('input')?.focus();
    });
    surprise.addEventListener('click', () => {
        const visible = cards.filter((card) => !card.hidden);
        const chosen = visible[Math.floor(Math.random() * visible.length)];
        if (!chosen) return;
        chosen.querySelector('details')!.open = true;
        chosen.querySelector('summary')!.focus({ preventScroll: true });
        chosen.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
            block: 'center',
        });
    });
    form.hidden = false;
    surprise.hidden = false;
    filter();
}
